/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Signup_Billing_YearlyInputs */

const en_signup_billing_yearly = /** @type {(inputs: Signup_Billing_YearlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yearly`)
};

const fr_signup_billing_yearly = /** @type {(inputs: Signup_Billing_YearlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Annuel`)
};

const de_signup_billing_yearly = /** @type {(inputs: Signup_Billing_YearlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jährlich`)
};

const it_signup_billing_yearly = /** @type {(inputs: Signup_Billing_YearlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Annuale`)
};

const ru_signup_billing_yearly = /** @type {(inputs: Signup_Billing_YearlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ежегодно`)
};

const es_signup_billing_yearly = /** @type {(inputs: Signup_Billing_YearlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anual`)
};

const zh_cn2_signup_billing_yearly = /** @type {(inputs: Signup_Billing_YearlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`每年`)
};

const ja_signup_billing_yearly = /** @type {(inputs: Signup_Billing_YearlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`年間`)
};

const hi_signup_billing_yearly = /** @type {(inputs: Signup_Billing_YearlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`सालाना`)
};

const pt_pt2_signup_billing_yearly = /** @type {(inputs: Signup_Billing_YearlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anual`)
};

/**
* | output |
* | --- |
* | "Yearly" |
*
* @param {Signup_Billing_YearlyInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const signup_billing_yearly = /** @type {((inputs?: Signup_Billing_YearlyInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Signup_Billing_YearlyInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_signup_billing_yearly(inputs)
	if (locale === "de") return de_signup_billing_yearly(inputs)
	if (locale === "it") return it_signup_billing_yearly(inputs)
	if (locale === "ru") return ru_signup_billing_yearly(inputs)
	if (locale === "es") return es_signup_billing_yearly(inputs)
	if (locale === "zh-CN") return zh_cn2_signup_billing_yearly(inputs)
	if (locale === "ja") return ja_signup_billing_yearly(inputs)
	if (locale === "hi") return hi_signup_billing_yearly(inputs)
	if (locale === "pt-PT") return pt_pt2_signup_billing_yearly(inputs)
	return en_signup_billing_yearly(inputs)
});